<template>
  <div class='sentence_root'>
    <div class='talker_content customer' v-if="role=='user'">
          <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-kehu"></use>
          </svg>
          <div class='content_customer'>
            {{sentence}}
          </div>
    </div>
    <div class='talker_content robot' v-else>
          <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-qiyekehu"></use>
          </svg>
          <div class='content_robot'>
            {{sentence}}
          </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { ElTooltip } from 'element-plus'

export default {
    setup() {
      let chat_font_size=ref('')

      if (window.screen.width >= 1080) {
        chat_font_size='0.13rem'
      }
      else if (window.screen.width >= 768) {
        chat_font_size='2vw'
      } 
      else {
        chat_font_size='2vw'
      }
      return {chat_font_size}
    },
    components: {
        ElTooltip
    },
    props:{
        sentence:{
            type:[String],
            // default:"默认值"
            // required:true
            default:function(){
                return []
            }
        },
        role:{
            type:[String],
            // default:"默认值"
            // required:true
            default:function(){
                return []
            }
        }
    }
}
</script>

<style scoped>

.sentence_root {
  overflow:hidden;
}

.talker_content {
  display: flex;
  justify-content: v-bind("role=='user'? 'flex-start':'flex-end'");
  flex-direction: v-bind("role=='user'? 'row':'row-reverse'");
  align-items: center;
  margin-bottom: 0.1rem;
}

.customer {
  float:left;
}

.robot {
    float: right;
}

.content_robot {
  margin-right: 0.1rem;
}

.content_customer,.content_robot {
  box-shadow: var(--el-box-shadow-light)
}

.icon {
  fill: currentColor;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .icon {
    width: 5vw;
    height: 5vw;
  }

  .content_customer {
    max-width: 92%;
    margin-left: 2vw;
  }

  .content_robot {
    max-width: 92%;
    margin-right: 2vw;
  }
}

@media screen and (max-width: 1080px) and (min-width: 768px) {
  .icon {
    width: 5vw;
    height: 5vw;
  }

  .content_customer {
    max-width: 92%;
    margin-left: 2vw;
  }

  .content_robot {
    max-width: 92%;
    margin-right: 2vw;
  }
}

@media screen and (min-width: 1080px)  {
  .icon {
    width: 0.3rem;
    height: 0.3rem;
  }

  .content_customer {
    max-width: 4.3rem;
    margin-left: 0.1rem;
  }

  .content_robot {
    max-width: 4.3rem;
    margin-right: 0.1rem;
  }
}


</style>